module.exports = __webpack_public_path__ + "img/technology-3.b0ee42a4.png";